import {makeStyles} from "@material-ui/core"
import {ModernTheme} from "../../../../../theme/modern/tokens"
import {COARSE, TOUCH_MIN} from "../../../../../theme/modern/touchTargets"

/** Ported from `record.css` `.sect` / `.params` / `.param`. */
export default makeStyles((theme: ModernTheme) => ({
    sect: {
        background: theme.modern.panel,
        border: `1px solid ${theme.modern.line}`,
        borderRadius: 12,
        padding: "9px 12px",
        boxShadow: theme.modern.shadow,
        display: "flex",
        flexDirection: "column",
        minWidth: 0,
        minHeight: 0,
        overflow: "auto",
    },
    sect_head: {
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        gap: "8px",
        marginBottom: 6,
    },
    microlabel: {
        font: `600 10px/1 ${theme.modern.sans}`,
        letterSpacing: ".12em",
        textTransform: "uppercase",
        color: theme.modern.ink2,
    },
    savestate: {
        font: `500 11px ${theme.modern.sans}`,
        color: theme.modern.ok,
        display: "inline-flex",
        alignItems: "center",
        gap: "5px",
        whiteSpace: "nowrap",
    },
    savestate__busy: {
        color: theme.modern.warn,
    },
    // the server refused the value and the cell has been rolled back
    savestate__rejected: {
        font: `500 11px ${theme.modern.sans}`,
        color: theme.modern.crit,
        display: "inline-flex",
        alignItems: "center",
        gap: "5px",
        minWidth: 0,
        maxWidth: "72%",
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap",
    },
    // "auto · editable" — tells the reviewer these came off the cart and can be
    // typed over, which is the whole contract of this card
    pill: {
        font: `500 10.5px ${theme.modern.mono}`,
        padding: "2.5px 8px",
        borderRadius: 99,
        background: theme.modern.panel2,
        border: `1px solid ${theme.modern.line}`,
        color: theme.modern.ink2,
        whiteSpace: "nowrap",
    },
    empty: {
        font: `400 12px ${theme.modern.sans}`,
        color: theme.modern.ink3,
    },

    params: {
        display: "grid",
        gridTemplateColumns: "repeat(auto-fit,minmax(74px,1fr))",
        gap: "5px",
        marginTop: 7,
    },

    "@keyframes modern_param_flash": {
        "0%, 16%": {background: theme.modern.okSoft},
        "100%": {background: theme.modern.panel2},
    },

    param: {
        background: theme.modern.panel2,
        border: `1px solid ${theme.modern.line}`,
        borderRadius: 9,
        padding: "6px 9px",
        minWidth: 0,
        transition: "background .12s",
    },
    param__editable: {
        cursor: "pointer",

        "&:hover": {background: theme.modern.accentSoft},
        "&:hover $param_value": {color: theme.modern.accent},
        // which tiles are editable is communicated by hover alone, so on a
        // tablet the press is the first and only confirmation
        "&:active": {background: theme.modern.accentSoft},
        "&:active $param_value": {color: theme.modern.accent},

        [COARSE]: {minHeight: TOUCH_MIN},
    },
    param__flash: {
        animation: "$modern_param_flash 1.4s ease",
    },
    param_label: {
        display: "flex",
        alignItems: "center",
        gap: "4px",
        font: `500 9.5px/1 ${theme.modern.sans}`,
        letterSpacing: ".08em",
        textTransform: "uppercase",
        color: theme.modern.ink3,
        whiteSpace: "nowrap",
        overflow: "hidden",
        textOverflow: "ellipsis",
    },
    param_heart: {
        width: 11,
        height: 11,
        flex: "none",
        color: theme.modern.crit,
    },
    param_value: {
        font: `600 16px/1.15 ${theme.modern.mono}`,
        marginTop: 3,
        display: "flex",
        alignItems: "baseline",
        gap: "4px",
        color: theme.modern.ink,

        "& small": {
            font: `500 10px ${theme.modern.mono}`,
            color: theme.modern.ink3,
        },
    },
    param_input: {
        width: "100%",
        maxWidth: 62,
        font: `600 15px ${theme.modern.mono}`,
        color: theme.modern.ink,
        background: theme.modern.panel,
        border: `1px solid ${theme.modern.accent}`,
        borderRadius: 5,
        padding: "0 4px",
        outline: "none",
    },
    // reference range / provenance line under the value
    param_range: {
        font: `400 9.5px ${theme.modern.mono}`,
        color: theme.modern.ink3,
        marginTop: 2,
        whiteSpace: "nowrap",
        overflow: "hidden",
        textOverflow: "ellipsis",
    },
}))
